export const detectOperatingSystem = () => {
  const isMac = navigator.userAgent.indexOf('Mac') !== -1;
  return isMac ? 'CMD' : 'CTRL';
};
